// extracted by mini-css-extract-plugin
export default {"root":"TradedAmount_root__7mT1b","icon":"TradedAmount_icon__Q9RBy"};